import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => navigate("/"), 2000);
  }, [navigate]);

  return (
    <div className="text-center p-8">
      <h1 className="text-3xl font-bold text-green-500">
        {"Paiement réussi !"}
      </h1>
      <p className="mt-4">
        {
          "Merci pour votre abonnement, vous allez être redirigé sur la plateforme dans un instant !"
        }
      </p>
    </div>
  );
};

export default SuccessPage;
